import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCup: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cup, tea, coffee, mug"><path d="M3.75 3.75H16.25V20.25H3.75V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M16.25 6.75H20.25V12.25H16.25V6.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCup;
